import {combineReducers} from 'redux';

import bounds from './bounds';

export default combineReducers({
  bounds
});
